import normalizeHashRoutes from '../../lib/util/normalize_hash_routes'

export function peUrlParams () {
  return new URL(normalizeHashRoutes(document.URL)).searchParams
}
